import * as React from 'react'; // Tell cell that browser support sticky

var StickyContext = /*#__PURE__*/React.createContext(false);
export default StickyContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/es/context/StickyContext.js
// module id = 1064
// module chunks = 1